<template>
  <v-card
    :height="widgetHeight"
    :min-width="widgetWidth"
    class="ma-0 pa-0"
    :loading="loading"
  >
    <v-card-title v-if="!loading" class="pa-0 ma-0">
      <widget-header
        :title="getTitle"
        :color="settingsModel.color ? settingsModel.color : '#0097a7'"
        :titleColor="settingsModel.textColor"
        icon="mdi-calendar-clock"
      >
        <template slot="actions">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                :color="settingsModel.textColor"
                @click.prevent="refresh"
                >mdi-refresh</v-icon
              >
            </template>
            <span>{{ $t("Refresh") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                :color="settingsModel.textColor"
                @click.prevent="showSettings"
                >mdi-cog</v-icon
              >
            </template>
            <span>{{ $t("Settings") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                :color="settingsModel.textColor"
                @click.prevent="removeWidget"
                >mdi-delete</v-icon
              >
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </template>
      </widget-header>
    </v-card-title>
    <v-card-text class="pa-0 ma-0">
      <base-no-data v-if="!loading && !hasData && widgetHeight > 39" />
      <v-list
        shaped
        v-if="!loading && hasData"
        :style="{ 'max-height': contentHeight + 'px' }"
        class="ma-0 pa-0 mt-1 overflow-y-auto"
      >
        <template v-for="(item, index) in data">
          <div :key="`dashboard-history-item-${item.Id}${widgetId}`">
            <v-divider v-if="index > 0"></v-divider>
            <v-list-item :to="getRoute(item)" style="min-height: 35px">
              <v-list-item-content class="ma-0 pa-1">
                <v-list-item-title
                  v-text="item.Description"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon class="ma-0 pa-1">
                <v-chip color="grey lighten-3">
                  <v-avatar left class="grey lighten-1"
                    >{{ item.Count }}
                  </v-avatar>
                  {{ item.Date }}
                </v-chip>
              </v-list-item-icon>
            </v-list-item>
          </div>
        </template>
      </v-list>
      <widget-settings-modal :ref="modalKey" @on-save="onSettingsSave" />
    </v-card-text>
    <v-card-actions></v-card-actions>
  </v-card>
</template>

<script>
import WidgetSettingsModal from "@/components/widgets/WidgetSettingsModal";
import WidgetSettings from "@/ecm/models/WidgetSettings";
import WidgetService from "@/services/WidgetService";
import WidgetHeader from "@/components/widgets/WidgetHeader";
import SearchType from "@/ecm/variables/SearchType";

export default {
  components: { WidgetHeader, WidgetSettingsModal },
  name: "WidgetSearchHistory",
  props: {
    widgetId: {
      type: Number,
      default: 0,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    settings: { type: Object },
  },
  mounted() {
    this.widgetHeight = this.height;
    this.widgetWidth = this.width;
    this.settingsModel = new WidgetSettings(this.widgetId, this.settings);
    this.refresh();
  },
  data() {
    return {
      title: this.$t("WidgetSearchHistoryTitle"),
      hasData: false,
      color: "",
      loading: false,
      headerHeight: 40,
      widgetHeight: 0,
      widgetWidth: 20,
      settingsModel: new WidgetSettings(),
      modalKey: "modalSettingsKey",
    };
  },
  methods: {
    resize(height, width) {
      this.widgetHeight = height;
      this.widgetWidth = width;
    },
    showSettings() {
      this.modalSettings.show(
        this.id,
        this.widgetId,
        this.settingsModel.toDto()
      );
    },
    onSettingsSave(dto) {
      this.settingsModel = new WidgetSettings(this.widgetId, dto);
    },
    refresh() {
      this.loading = true;

      WidgetService.getData({
        WidgetID: this.widgetId,
      }).then((data) => {
        this.loading = false;

        if (data.length == 0) {
          this.hasData = false;
          return;
        }

        this.data = data;
        this.hasData = true;
      });
    },
    removeWidget() {
      this.$emit("on-remove-widget", this.id);
    },
    getRoute(audit) {
      if (audit.SearchType == SearchType.Basket) {
        return `/search/${SearchType.Basket}/${audit.BasketID}`;
      }

      if (audit.SearchType == SearchType.UserSearch) {
        return `/search/${SearchType.UserSearch}/${audit.UserSearchID}`;
      }

      var pattern = {
        searchAllVersions: audit.SearchAllVersions,
        contentTypeIDs: audit.ContentTypeIDs,
        searchPattern: audit.SearchPattern,
      };

      return `/search/${audit.SearchType}/${encodeURIComponent(
        JSON.stringify(pattern)
      )}`;
    },
  },
  computed: {
    modalSettings() {
      return this.$refs[this.modalKey];
    },
    getTitle() {
      if (this.settingsModel.widgetTitle) {
        return this.settingsModel.widgetTitle;
      } else {
        return this.title;
      }
    },
    contentHeight() {
      return this.widgetHeight - this.headerHeight;
    },
  },
};
</script>
